<template>
  <div>
    <header>
      <div class="logo-wrap">
        <div class="logo" @click="home" style="cursor: pointer">
          <img src="../../assets/imgs/logo.png" alt="首页">
        </div>
        <div class='search'>
          <form>
            <input type="text" v-model="searchStr" id="src_key" class="search-input" :placeholder="placeholderStr">
            <input id="searchSubmit" class="search-btn" type="submit" value="搜索" @click="toSearch">
          </form>
        </div>
        <div class="login-btn">
          <div v-if="isLogin" class="is-login">
            <span class="avatar">
              <img :src="userInfo.avatar" alt="">
            </span>
            <div>
              <div class="ft-blue">{{userInfo.username}}</div>
              <div>
                <span @click="home">我的书架 | </span>
                <span class="register-author" @click="registerAuthor">成为作者 | </span>
                <span @click="home">退出</span>
              </div>
            </div>
          </div>
          <div v-else>
            <span class="login-btn__icon"></span>
            <span class="login-btn__text" @click="home" style="cursor: pointer">登录/注册</span>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
  import {getUserInfoByToken} from "../../assets/js/api/api";

  export default ({
    data () {
      return {
        searchStr: '',
        placeholderStr: '修罗天帝',
        userInfo: {},
        isLogin: false,
      }
    },
    created() {
      this.getUserInfo();
    },
    methods: {
      async getUserInfo () {
        let res = await getUserInfoByToken();
        if (res.code === 1000) {
          this.userInfo = res.data;
          this.isLogin = true
        } else {
          this.isLogin = false;
        }
      },
      home () {
        window.open('//www.iyoule.com')
      },
      toSearch () {
        const query = this.searchStr ? this.searchStr : this.placeholderStr;
        window.open(`//www.iyoule.com/search_new.php?q=${query}`);
      },
      registerAuthor() {
        // this.$router.push('/author/register')
        window.open('//www.iyoule.com/author.php');
      }
    }
  })
</script>

<style lang="less" scoped>
  button, input {
    border: none;
    outline: 0;
  }

  header {
    background: url('../../assets/imgs/topbgimg.png');
    width: 100%;
    height: 74px;

    .logo-wrap {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .logo {
        height: 52px;
        margin-top: 22px;
      }
      .search {
        .search-input {
          width: 300px;
          height: 35px;
          border: 1px solid #dbdbdb;
          border-radius: 5px;
        }

        .search-btn {
          height: 35px;
          margin-left: 15px;
          font-size: 16px;
          font-weight: 600;
          color: #4c4b4b;
          background: rgba(255, 255, 255, 0);
        }
      }

      .login-btn {
        height: 40px;
        .is-login {
          display: flex;
          img {
            height: 48px;
            width: 48px;
            border-radius: 50%;
          }
          .register-author {
            cursor: pointer;
          }
        }
        .login-btn__icon {
          height: 48px;
          width: 48px;
          display: inline-block;
          background: url("../../assets/imgs/login_icon.png");
          vertical-align: middle;
        }

        .login-btn__text {

        }
      }
    }
  }
</style>
